import React from 'react';
import Session from "../../../../services/Session";
export default function Role(props) {
    if (!props.roles.find(function (role) { return Session.user.organisation.userRole === role; })) {
        return null;
    }
    return React.createElement(React.Fragment, null, props.children);
}
